import React, {Component, Fragment} from 'react';
import {observer} from "mobx-react";
import AutosizeInput from 'react-input-autosize';
// import MaskedInput from 'react-text-mask';
import {IMaskInput} from 'react-imask';
import IMask from 'imask';
import Tooltip from "../../Helpers/Tooltip";

class Date extends Component {
  constructor(props) {
    super(props);
    this.state={
      show_tooltip:false
    };
  }
  render() {
    if(this.props.locked) {
      return this.props.item.value;
    }
    const y={ mask: IMask.MaskedRange, from: 0, to: 9999 };
    const a={ mask: IMask.MaskedRange, from: 0, to: 99999999999999 };
    const m={ mask: IMask.MaskedRange, from: 0, to: 12 };
    const d={ mask: IMask.MaskedRange, from: 0, to: 31 };
    const h={ mask: IMask.MaskedRange, from: 0, to: 23 };
    const i={ mask: IMask.MaskedRange, from: 0, to: 59 };
    const s={ mask: IMask.MaskedRange, from: 0, to: 59 };
    const t={ mask: IMask.MaskedEnum, enum: ['>','<','=','~','!'] };
    const r={ mask: IMask.MaskedEnum, enum: ['=',''] };
    // const r={ mask: /^[\>\=\<\!~]?\=?.*$/i };
    return (
      <div>
        <Tooltip show={this.state.show_tooltip} text="Допускается ввод неполных дат. Полный формат даты выглядит так: 2020-01-01 20:15:13">
          <IMaskInput
            onFocus={()=>{ this.setState({ show_tooltip:true }); }}
            onBlur={()=>{ this.setState({ show_tooltip:false }); }}
            style={{width:127}}
            mask={[
              { mask: '[t]a', blocks: { t:t, a:a } },
              { mask: '[tr]a', blocks: { t:t, r:r, a:a } },
              { mask: 'yyyy', blocks: { yyyy: y, t:t, r:r } },
              { mask: 'yyyy-mm', blocks: { yyyy: y, mm: m, t:t, r:r  } },
              { mask: 'yyyy-mm-dd', blocks: { yyyy: y, mm: m, dd: d, t:t, r:r  } },
              { mask: 'yyyy-mm-dd hh', blocks: { yyyy: y, mm: m, dd: d, hh: h, t:t, r:r  } },
              { mask: 'yyyy-mm-dd hh:ii', blocks: { yyyy: y, mm: m, dd: d, hh: h, ii: i, t:t, r:r  } },
              { mask: 'yyyy-mm-dd hh:ii:ss', blocks: { yyyy: y, mm: m, dd: d, hh: h, ii: i, ss:s, t:t, r:r  } },
              /*
              { mask: 'yyyy', blocks: { yyyy: y, t:t, r:r } },
              { mask: '[t]yyyy', blocks: { yyyy: y, t:t, r:r } },
              { mask: '[tr]yyyy', blocks: { yyyy: y, t:t, r:r } },
              { mask: 'yyyy-mm', blocks: { yyyy: y, mm: m, t:t, r:r  } },
              { mask: '[t]yyyy-mm', blocks: { yyyy: y, mm: m, t:t, r:r  } },
              { mask: '[tr]yyyy-mm', blocks: { yyyy: y, mm: m, t:t, r:r  } },
              { mask: 'yyyy-mm-dd', blocks: { yyyy: y, mm: m, dd: d, t:t, r:r  } },
              { mask: '[t]yyyy-mm-dd', blocks: { yyyy: y, mm: m, dd: d, t:t, r:r  } },
              { mask: '[tr]yyyy-mm-dd', blocks: { yyyy: y, mm: m, dd: d, t:t, r:r  } },
              { mask: 'yyyy-mm-dd hh', blocks: { yyyy: y, mm: m, dd: d, hh: h, t:t, r:r  } },
              { mask: '[t]yyyy-mm-dd hh', blocks: { yyyy: y, mm: m, dd: d, hh: h, t:t, r:r  } },
              { mask: '[tr]yyyy-mm-dd hh', blocks: { yyyy: y, mm: m, dd: d, hh: h, t:t, r:r  } },
              { mask: 'yyyy-mm-dd hh:ii', blocks: { yyyy: y, mm: m, dd: d, hh: h, ii: i, t:t, r:r  } },
              { mask: '[t]yyyy-mm-dd hh:ii', blocks: { yyyy: y, mm: m, dd: d, hh: h, ii: i, t:t, r:r  } },
              { mask: '[tr]yyyy-mm-dd hh:ii', blocks: { yyyy: y, mm: m, dd: d, hh: h, ii: i, t:t, r:r  } },
              { mask: 'yyyy-mm-dd hh:ii:ss', blocks: { yyyy: y, mm: m, dd: d, hh: h, ii: i, ss:s, t:t, r:r  } },
              { mask: '[t]yyyy-mm-dd hh:ii:ss', blocks: { yyyy: y, mm: m, dd: d, hh: h, ii: i, ss:s, t:t, r:r  } },
              { mask: '[tr]yyyy-mm-dd hh:ii:ss', blocks: { yyyy: y, mm: m, dd: d, hh: h, ii: i, ss:s, t:t, r:r  } },
               */
            ]}
            className="small"
            type="text"
            value={this.props.item.value}
            unmask={false} // true|false|'typed'
            inputRef={(ref) => { this.props.inputRef(ref); }}  // access to nested input
            // DO NOT USE onChange TO HANDLE CHANGES!
            // USE onAccept INSTEAD
            onKeyDown={(e)=>{
              this.props.onKeyDown(e);
            }}
            onAccept={
              // depending on prop above first argument is
              // `value` if `unmask=false`,
              // `unmaskedValue` if `unmask=true`,
              // `typedValue` if `unmask='typed'`
              (value, mask) => {
                const arg=value.matchAll(/([<>=!~]?[=]?)([0-9]+)/gi).next();
                if(arg.value) {
                  if (arg.value[2]) {
                    if (arg.value[1] === '~' || arg.value[1] === '=' || arg.value[1] === '!=' || arg.value[1] === '>' || arg.value[1] === '<' || arg.value[1] === '>=' || arg.value[1] === '<=') {
                      this.props.item.compare = arg.value[1];
                      value = arg.value[2];
                    }
                  }
                }
                this.props.item.value=value;
              }
            }
            // ...and more mask props in a guide

            // input props also available
            placeholder='Введите дату'
          />
        </Tooltip>
      </div>
    )
  }
}

export default observer(Date);